import styled from 'styled-components';
import { Image } from '@hotelplan/components.common.image';
import { sx2CssThemeFn } from '@hotelplan/libs.sx';

export const PdpGeoPageTitle = styled.h2(
  sx2CssThemeFn({
    color: 'secondary',
    mb: [2, 3],
    fontSize: ['18px', '26px'],

    span: {
      color: 'textGray',
    },
  })
);

export const PdpGeoPageText = styled.div(
  sx2CssThemeFn({
    lineHeight: '1.7',
    fontSize: 0,
    mb: [3, 4],
  })
);

export const PdpGeoPageImage = styled(Image)(
  sx2CssThemeFn({
    width: '100%',
    height: 'auto',
    borderRadius: '5px',
    border: '1px solid',
    borderColor: 'borderGray',
    mb: 4,
  })
);

export const PdpGeoPageSubTitle = styled.h3(
  sx2CssThemeFn(({ theme: { media } }) => ({
    color: 'secondary',
    mb: 3,
    fontSize: ['18px', '26px'],

    [media.mobile]: {
      textAlign: 'center',
    },
  }))
);
